import { LitElement, html, css, PropertyValues } from 'lit';
import { customElement, state, query } from 'lit/decorators.js';
import '@shoelace-style/shoelace/dist/components/alert/alert'
import '@shoelace-style/shoelace/dist/components/input/input'
import '@shoelace-style/shoelace/dist/components/button/button'
import '@shoelace-style/shoelace/dist/components/spinner/spinner'
import SlInput from '@shoelace-style/shoelace/dist/components/input/input';

@customElement('vxc-login')
export class TLogin extends LitElement {
  static styles = css`
    :host {
        display: flex;
        height: 100vh;
        width: 100vw;
        justify-content: center;
        align-items: center;
        --sl-input-label-font-size-medium: .7rem;
        --sl-input-focus-ring-color: black;
        --sl-focus-ring-style: solid;
        --sl-focus-ring-width: 1px;
        --sl-input-border-width: 1px;
        --sl-input-focus-ring: var(--sl-focus-ring-style) var(--sl-focus-ring-width) var(--sl-input-focus-ring-color);
        --sl-input-focus-ring-offset: 0px;
    }

    .form-container {
      background: white;
      padding: 2rem;
      border-radius: 12px;
      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
      width: 300px;
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    .header {
        text-align: center;
        font-size: 1.5rem;
        margin-top: -1rem;
        margin-bottom: 3rem;
    }

    .err-msg {
        font-size: .7rem;
        text-align: center;
        color: red;
    }

    sl-button::part(base) {
        width: 300px;
        margin-top: 1rem;
    }
  `;

    @state() private errorMessage = ''
    @state() private loading = false
    @query('#username')     username!:SlInput
    @query('#password')     password!:SlInput

    private async handleLogin(e: Event) {
        e.preventDefault()
        this.errorMessage = '';
        this.loading = true;
        try {
            // const result = await window.app.login(this.username, this.password);
            if(!window.voxyapp)     throw new Error('Login failed : system not initialized..')
            const username = this.username.value
            const password = this.password.value
            var result = await window.voxyapp.login(username, password)
            if (!result) this.errorMessage = 'Invalid username or password.'
            else this.dispatchEvent(new CustomEvent('logged-in', { detail: {} }))
        } 
        catch (err) { this.errorMessage = 'Login failed. Please try again.' } 
        finally { this.loading = false }
    }

    protected firstUpdated(changedProperties: PropertyValues): void {
        if(window.voxyapp?.loggedIn())  
            this.dispatchEvent(new CustomEvent('logged-in', { detail: {} }))
        super.firstUpdated(changedProperties)
    }

    render() {
        return html`
            <div class="form-container">
                <div class="header">Login</div>
                <form @submit=${this.handleLogin}>
                    <sl-input 
                        id="username"
                        label="Username" 
                        name:"username"
                        clearable 
                        required >
                    </sl-input>
                    <sl-input 
                        id="password"
                        label="Password" 
                        name="password"
                        type="password" 
                        password-toggle 
                        required >
                    </sl-input>
                    <div class="err-msg">${this.errorMessage}</div>
                    <sl-button 
                        variant="neutral" 
                        ?disabled=${this.loading}
                        type="submit" >
                        ${this.loading ? html`<sl-spinner slot="prefix"></sl-spinner>` : 'Login'}
                    </sl-button>
                </form>
            </div>
        `;
    }
}

declare global {
  interface HTMLElementTagNameMap {
    'vxc-login': TLogin;
  }
}


// test1@me.com
// abcdefghijklm